<template>
    <auth-background :path="path" :visible="status > 1" @back="backHandler">
        <auth-styled>
            <transition-group name="slide-fade">
                <auth-login
                    v-if="!isAuthCode && status <= 1"
                    :status="status"
                    :path="path"
                    :key="0"
                    @check-user="checkUserHandler"
                    @status="statusHandler"
                />

                <auth-config-password
                    v-if="!isAuthCode && status === 2"
                    :token="token"
                    :phone="phone"
                    :key="1"
                    @login="loginHandler"
                    @push-page="goHandler"
                />

                <auth-code v-if="isAuthCode" :phone="phone" :key="2" @auth-code="authCodeHandler" />

                <auth-password
                    v-if="!isAuthCode && status === 3"
                    :phone="phone"
                    :key="3"
                    @login="loginHandler"
                    @push-page="goHandler"
                    @prev-code="prevHandler"
                />

                <!-- <div v-else>Not Found Page</div> -->
            </transition-group>
        </auth-styled>
    </auth-background>
</template>
<script>
import { mapMutations, mapState, mapActions } from "vuex";
import styled from "vue-styled-components";
import { dataEncoded } from "../../../utils/lib";

import AuthBackground from "../components/AuthBackground";
import AuthLogin from "../components/AuthLogin";
import AuthCode from "../components/AuthCode";
import AuthConfigPassword from "../components/AuthConfigPassword";
import AuthPassword from "../components/AuthPassword";

const AuthStyled = styled("div")`
    position: relative;
    padding-left: 4.8rem;
    width: 100%;

    .auth-title {
        font-size: 3.2rem;
        line-height: 5.2rem;
    }

    .auth-waring,
    .pw-re-config {
        font-size: 1.4rem;
        color: ${props => props.theme.color.disabled};
    }

    .pw-re-config,
    .re-send-code {
        user-select: none;

        span.abled-span {
            cursor: pointer;
            color: ${props => props.theme.color.primary};
            font-weight: bold;
        }
    }

    .error-text {
        padding: 0.8rem;
        font-size: 1.4rem;
        height: 3rem;
        color: ${props => props.theme.color.red};
    }

    .auto-login-checkbox {
        padding-left: 0.4rem;
    }
`;

export default {
    name: "AuthContainer",
    data: () => ({
        phone: null,
        status: 0, // 0, 1 폰받기 , 2 새로운 비번 , 3 기존 비번
        isAuthCode: false, // 인증번호 페이지 on/off
        prev: [],
        path: {
            android: "https://play.google.com/store/apps/details?id=kr.onbi.schoolmom",
            ios: "https://apps.apple.com/kr/app/id985000712"
        }
    }),
    computed: {
        ...mapState("user", {
            token: "token"
        })
    },
    methods: {
        ...mapMutations("user", ["SET_TOKEN"]),
        ...mapActions("user", ["GET_PROPERTY"]),

        statusHandler(index) {
            this.status = index;
        },

        backHandler() {
            // 이전 기록 없으면 무조건 초기화면
            if (!this.prev.length === 0) {
                this.goHandler("phone-login");
                return;
            }

            const prev = this.prev.splice(this.prev.length - 1, this.prev.length);
            this.goHandler(prev[0]);
        },

        prevHandler(code) {
            this.prev.push(code);
        },

        // 2-2 step
        goHandler(code) {
            // 핸드폰로그인 화면
            if (code === "phone-login") {
                this.statusHandler(0);
                this.isAuthCode = false;
                return;
            }

            // 비번로그인 화면
            if (code === "pw-login") {
                this.statusHandler(3);
                this.isAuthCode = false;
                return;
            }

            // 비번 재설정 인증코드
            if (code === "auth-code") {
                this.statusHandler(2);
                this.isAuthCode = true;
                return;
            }
        },

        // 3 step
        loginHandler(result) {
            // 마지막 로그인 후 필요한 property를 가져온다.
            this.GET_PROPERTY({ result, $router: this.$router, $alert: this.$alert });
        },

        // 2-1 step
        authCodeHandler(result) {
            this.SET_TOKEN(result.token);
            this.isAuthCode = false;

            this.$alert("success", "인증에 성공했습니다.");
        },

        // 1 step
        checkUserHandler(result) {
            const { response, phone, hook } = result;
            const { status } = response.data;
            this.phone = phone;

            // smsPhone 자동등록
            if (status === 1) hook && hook();

            this.statusHandler(status);

            this.prevHandler("phone-login"); // back code

            // 최초 pc 로그인시 새 비밀번호 받아야함
            if (status === 2) {
                this.isAuthCode = true;
            }
        }
    },
    components: {
        AuthStyled,
        AuthBackground,
        AuthLogin,
        AuthCode,
        AuthConfigPassword,
        AuthPassword
    }
};
</script>
